<template>
  <v-btn rounded="0" density="compact" color="grey-lighten-2" flat v-on:click="dialog = true">
    СОЗДАТЬ ДУБЛИКАТ
  </v-btn>

  <v-dialog persistent scrollable width="700" style="backdrop-filter: blur(2px) grayscale(80%)" v-model="dialog">
    <template v-slot:default>
      <v-card rounded="xl" class="ma-0 pa-0" density="compact">
        <template v-slot:title>
          СОЗДАТЬ ДУБЛИКАТ ДОКУМЕНТА
        </template>
        <template v-slot:text>
          <VueDatePicker
              :min-date="new Date()"
              :teleport="true"
              ref="dp" locale="ru-RU"
              v-model="date"
              :format="formatDate"
              select-text="ВЫБРАТЬ"
              cancel-text="ЗАКРЫТЬ"
              :enable-time-picker="false"
          />
        </template>
        <template v-slot:prepend>
          <v-btn
              flat
              color="red"
              size="small"
              :icon="true"
              @click="dialog = false"
          >
            <v-icon :icon="['fas', 'xmark']" />
          </v-btn>
        </template>
        <template v-slot:append>
          <v-btn
              flat
              color="green"
              rounded="pill"
              @click="duplicate()"
          >
            ПРИМЕНИТЬ
          </v-btn>
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { EventsList } from "@/store/wp_planner/events.store";
import moment from "moment";
import { LoadedWeeks } from "@/store/wp_planner/misc.store";
import { UUID } from "@/libs/magic";

export default {
  name: "Duplicate__WP_Dialog",
  props: ['element'],
  data() {
    return {
      dialog: false,
      date: null
    }
  },
  methods: {
    moment,
    duplicate: function () {
      let copy = JSON.parse(JSON.stringify(this.element))
      copy.__ID = this.element.guid+"_"+UUID()
      copy.date.secret = false
      copy.is_duplicated = true
      delete copy.permanent
      copy.date.desire = moment(this.date).format("YYYY-MM-DD[T]00:00:00")
      copy.persons = []
      this.events.push(copy)

      this.dialog = false
    },
    formatDate: function (date) {
      if (date) {
        let d = date.getDate()
        let m = date.getMonth() + 1
        let y = date.getFullYear()
        d = d < 10 ? '0' + d : d
        m = m < 10 ? '0' + m : m
        return `В плане на: ${d}.${m}.${y}`;
      } else {
        return 'Выберите второе число'
      }
    }
  },
  computed: {
    /*duplicates() {
      return this.events.filter(ev=>ev.guid === this.element.guid && ev.__ID !== this.element.__ID )
    },
    max_date() {
      let dates = []
      if (this.loaded_weeks.length > 0) {
        for (let date of this.loaded_weeks) {
          dates.push(moment(date).endOf('week').toDate())
        }
      } else {
        dates.push(moment().endOf('week').toDate())
      }
      let maxDate = new Date(Math.max.apply(null,dates));
      return maxDate
    },
    disabledDates() {
      let dates = []
      dates.push(this.element.date.desire)
      for (let ev of this.duplicates) {
        dates.push(ev.date.desire)
      }
      return dates
    },*/
    loaded_weeks: {
      get() {
        return LoadedWeeks().get()
      },
      set(value) {
        LoadedWeeks().set(value)
      }
    },
    events: {
      get() {
        return EventsList().get()
      },
      set(value) {
        EventsList().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
